import logo from '../assets/jet-logo.jpg';
import './BrandMark.css';

interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  stacked?: boolean;
}

export function BrandMark({ size = 'sm', stacked = false }: BrandMarkProps) {
  return (
    <div className={`brand-mark brand-mark--${size}${stacked ? ' brand-mark--stacked' : ''}`}>
      <div className="brand-mark__emblem-wrap">
        <img src={logo} alt="JETSTORE" className="brand-mark__emblem" />
      </div>
      <span className="brand-mark__store">JETSTORE</span>
    </div>
  );
}
